import React, { forwardRef } from "react";
import classNames from "classnames";
import { UniqueIdentifier } from "@dnd-kit/core";

import { AccordionContainersType } from "../../../../../../../types/working-model";
import { useTypedSelector } from "../../../../../../../store/reducers/use-typed-selector";
import { OptionalComponent } from "../../../../../../../utils/optional-component";
import Icon, { ICONS } from "../../../../../../general-ui/icon";
import { COLORS } from "../../../../../../general-ui/icon";

import styles from "../../../../../../../scss/live-event/base/modules/accordion modules/accordion-container.module.scss";


export interface AccordionContainerProps {
	children: React.ReactNode;
	columns?: number;
	style?: React.CSSProperties;
	horizontal?: boolean;
	hover?: boolean;
	scrollable?: boolean;
	shadow?: boolean;
	placeholder?: boolean;
	unstyled?: boolean;
	onClick?(): void;
	onRemove?(): void;
	containers?: AccordionContainersType;
	containerId?: UniqueIdentifier;
	vertical?: boolean;
	showContainerActions?: boolean;
}

// any should be HTMLButtonElement but it doesn't work properly
const AccordionContainer = forwardRef<any, AccordionContainerProps>(
	(
		{
			children,
			columns = 1,
			horizontal,
			hover,
			onClick,
			onRemove,
			placeholder,
			style,
			scrollable,
			shadow,
			unstyled,
			containers = [],
			containerId,
			vertical,
			showContainerActions = false,
			...props
		}: AccordionContainerProps,
		ref
	) => {
		const Component = onClick ? "button" : "div";

		const focusedContainer = useTypedSelector(state => state.CreateEventReducer.accordion.focusedContainer);

		const isLastContainer = containers.length > 1 && containers[containers.length - 1] === containerId;

		return (
			<Component
				{...props}
				ref={ref}
				style={
					{
						...style,
						"--columns": columns
					} as React.CSSProperties
				}
				className={classNames(
					'accordion-column',
					styles.Container,
					unstyled && styles.unstyled,
					horizontal && styles.horizontal,
					hover && styles.hover,
					placeholder && styles.placeholder,
					scrollable && styles.scrollable,
					shadow && styles.shadow,
					containerId && containerId === focusedContainer && styles.editing,
					vertical && styles.vertical,
					isLastContainer && styles.isLastContainer
				)}
				onClick={onClick}
				tabIndex={onClick ? 0 : undefined}
			>
				<OptionalComponent display={showContainerActions}>
					<div className={styles.Header}>
						<div className={styles.Actions}>
							<OptionalComponent display={containers.length > 1}>
								<>
									{onRemove ? <button onClick={onRemove} className="round"><Icon name={ICONS.TRASH_OUTLINE} color={COLORS.WHITE} size={12} /></button> : undefined}
								</>
							</OptionalComponent>
						</div>
					</div>
				</OptionalComponent>
				{placeholder ? children : <ul>{children}</ul>}
			</Component>
		);
	}
);

AccordionContainer.displayName = 'AccordionContainer';

export default AccordionContainer;
